import "./TheKitchen.module.css";
import Header from "@/reusable_sections/Header";
import MeetTheKitchenTeam from "./sections/MeetTheKitchenTeam";
import TheCurrentRotation from "./sections/TheCurrentRotation";
import Footer from "@/reusable_sections/Footer";
export default function TheKitchenPage() {
  return <div>
      <Header />
      <MeetTheKitchenTeam />
      <TheCurrentRotation />
      <Footer />
    </div>;
}